'use client';

import { c as _c } from "react/compiler-runtime";
import { FC, useMemo, useRef } from 'react';
import useDevice from '@/hooks/useDevice';
import CasesSliderDesktop from './components/CasesSliderDesktop';
import CasesSliderMobile from './components/CasesSliderMobile';
import { CasesSliderScrollDto } from './types';
import { getLayoutFromData } from './utils/getLayoutFromData';
interface Props {
  data?: CasesSliderScrollDto;
  showIndex?: boolean;
  className?: string;
  withContainer?: boolean;
}
const CasesSliderScroll: FC<Props> = t0 => {
  const $ = _c(13);
  const {
    data,
    showIndex: t1,
    className,
    withContainer
  } = t0;
  const showIndex = t1 === undefined ? false : t1;
  const device = useDevice();
  const isMobile = device === "mobile";
  let t2;
  if ($[0] !== data?.cases) {
    t2 = data?.cases ?? [];
    $[0] = data?.cases;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const cases = t2;
  const mobileSectionRef = useRef(null);
  let t3;
  if ($[2] !== cases || $[3] !== showIndex) {
    t3 = getLayoutFromData(cases, showIndex);
    $[2] = cases;
    $[3] = showIndex;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const layout = t3;
  if (!cases.length) {
    return null;
  }
  if (isMobile) {
    let t4;
    if ($[5] !== cases || $[6] !== className) {
      t4 = <CasesSliderMobile cases={cases} sectionRef={mobileSectionRef} className={className} />;
      $[5] = cases;
      $[6] = className;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  let t4;
  if ($[8] !== cases || $[9] !== className || $[10] !== layout || $[11] !== withContainer) {
    t4 = <CasesSliderDesktop cases={cases} layout={layout} className={className} withContainer={withContainer} />;
    $[8] = cases;
    $[9] = className;
    $[10] = layout;
    $[11] = withContainer;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export default CasesSliderScroll;